import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENDPOINTS, URLS } from '@shared/constants';
import {
  CommonResponseDTO,
  ISubscriber,
  ISubscriberRequest,
} from '@shared/interfaces';
import { generateURL } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class PublicSubscribersService {
  constructor(private http: HttpClient) {}

  public createSubscriber(
    subscriber: ISubscriberRequest
  ): Observable<CommonResponseDTO<ISubscriber>> {
    const url = generateURL({ endpoint: ENDPOINTS.SUBSCRIBERS_CREATE_NEW });
    return this.http.post<CommonResponseDTO<ISubscriber>>(url, subscriber);
  }
  public deleteSubscriber(
    id: string
  ): Observable<CommonResponseDTO<ISubscriber>> {
    const url = generateURL({
      endpoint: ENDPOINTS.SUBSCRIBERS_DELETE,
      params: { id },
    });
    return this.http.delete<CommonResponseDTO<ISubscriber>>(url);
  }

  findEmailDuplicates(mail: string) {
    const url = `${URLS.PUBLIC_SUBSCRIPTION}/previous-subscriptions`;
    const params = new HttpParams().set('mail', mail);

    return this.http.get<CommonResponseDTO<number>>(url, { params });
  }
}
